import React, { Fragment, useState, useEffect } from "react";

import Grid from "@material-ui/core/Grid";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import clsx from "clsx";
import Drawer from "@material-ui/core/Drawer";
import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import {
  Home,
  AddShoppingCart,
  Dehaze,
  ArrowForwardIos,
  AssignmentInd,
} from "@material-ui/icons";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";

const drawerWidth = 180;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
  },
  drawerPaper: {
    width: drawerWidth,
    background: "#e9ebee",
    marginTop: "62px",
  },
  toolbar: {
    marginTop: "30%",
  },
  drawerClose: {
    marginTop: "50px",
  },
  imgUser: {
    width: "70px",
    height: "70px",
    backgroundPosition: "center",
    objectFit: "cover",
    borderRadius: "50%",
    marginTop: "15%",
    marginBottom: "15px",
    border: "2px solid #000",
  },
  listItemIcon: {
    minWidth: "35px",
  },
  itemIcon: {
    width: "20px",
  },
  itemMenu: {
    background: "#F8F8F8",
  },
  backgroundlistItemIcon: {
    lineHeight: "0px",
    background: "#F7F00B",
  },
  menuButton: {
    position: "absolute",
    top: "90px",
    background: "#FFFFFF",
    color: "#012168",
  },
  hide: {
    display: "none",
  },
  textBotom: {
    padding: "5px",
    fontFamily: '"Yanone Kaffeesatz", Sans-serif',
    letterSpacing: "1.5px",
    fontWeight: "600",
    textDecoration: "none",
  },
}));

export default function Menu(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [routeMenu, setRouteMenu] = useState("");
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [open, setOpen] = useState(true);
  const [containerLeft, setContainerLeft] = useState("15%");

  useEffect(() => {
    props.callbackRouta(routeMenu);
    props.callbackContainerLeft(containerLeft);
    setRouteMenu(routeMenu);
  }, [routeMenu, containerLeft]);

  const handleClickMenu = (prop) => (event) => {
    event.preventDefault();
    setOpenBackdrop(true);
    setTimeout(() => {
      setRouteMenu(prop);
      props.callbackRouta(routeMenu);
      setOpenBackdrop(false);
    }, 800);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
    setContainerLeft("15%");
  };

  const handleDrawerClose = () => {
    setOpen(false);
    setContainerLeft("5%");
  };

  return (
    <Fragment>
      <Grid item xs={12} sm={2}>
        <Tooltip title="Mostrar menú">
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <ArrowForwardIos />
          </IconButton>
        </Tooltip>
        <Drawer
          className={classes.drawer}
          variant="persistent"
          anchor="left"
          open={open}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            subheader={
              <ListSubheader
                className={classes.backgroundlistItemIcon}
                component="div"
                id="nested-list-subheader"
              >
                <Grid container>
                  <Grid item xs={9} sm={9}>
                    <center>
                      <img
                        src={props.changeImguser}
                        alt="avatar"
                        className={classes.imgUser}
                      />
                    </center>
                  </Grid>
                  <Grid item xs={3} sm={3}>
                    <Tooltip title="Ocultar menú">
                      <IconButton
                        onClick={handleDrawerClose}
                        className={classes.drawerClose}
                      >
                        {theme.direction === "ltr" ? (
                          <Dehaze />
                        ) : (
                          <ArrowForwardIos />
                        )}
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              </ListSubheader>
            }
          >
            <Divider style={{ marginTop: "1px" }} />

            <ListItem
              className={classes.itemMenu}
              button
              onClick={handleClickMenu("Home")}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <Home className={classes.itemIcon} />
              </ListItemIcon>
              <Typography variant="subtitle2" className={classes.textBotom}>
                Inicio
              </Typography>
            </ListItem>
            <Divider />

            {localStorage.getItem("perfil") === "2" ? (
              <Fragment>
                <ListItem
                  className={classes.itemMenu}
                  button
                  onClick={handleClickMenu("Miregistros")}
                >
                  <ListItemIcon className={classes.listItemIcon}>
                    <AssignmentInd className={classes.itemIcon} />
                  </ListItemIcon>
                  <Typography variant="subtitle2" className={classes.textBotom}>
                    Mi registro
                  </Typography>
                </ListItem>
                <Divider />

                <ListItem
                  className={classes.itemMenu}
                  button
                  onClick={handleClickMenu("Productos")}
                >
                  <ListItemIcon className={classes.listItemIcon}>
                    <AddShoppingCart className={classes.itemIcon} />
                  </ListItemIcon>
                  <Typography variant="subtitle2" className={classes.textBotom}>
                    Productos
                  </Typography>
                </ListItem>
                <Divider />
              </Fragment>
            ) : (
              <Fragment>
                <ListItem
                  className={classes.itemMenu}
                  button
                  onClick={handleClickMenu("MiregistrosDelivery")}
                >
                  <ListItemIcon className={classes.listItemIcon}>
                    <AssignmentInd className={classes.itemIcon} />
                  </ListItemIcon>
                  <Typography variant="subtitle2" className={classes.textBotom}>
                    Mi registro
                  </Typography>
                </ListItem>
                <Divider />
              </Fragment>
            )}
          </List>
        </Drawer>
      </Grid>
      <Backdrop
        style={{ zIndex: "9999", color: "#FFFFFF" }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  );
}
